__turbopack_context__.v({
  "backLink": "forgot-password-form-module__wuwdNW__backLink",
  "forgotPasswordBtn": "forgot-password-form-module__wuwdNW__forgotPasswordBtn",
  "forgotPasswordForm": "forgot-password-form-module__wuwdNW__forgotPasswordForm",
  "formBody": "forgot-password-form-module__wuwdNW__formBody",
  "formField": "forgot-password-form-module__wuwdNW__formField",
  "formInput": "forgot-password-form-module__wuwdNW__formInput",
  "formInputs": "forgot-password-form-module__wuwdNW__formInputs",
  "formSubtitle": "forgot-password-form-module__wuwdNW__formSubtitle",
  "formTitle": "forgot-password-form-module__wuwdNW__formTitle",
  "formTitleHeading": "forgot-password-form-module__wuwdNW__formTitleHeading",
  "serverError": "forgot-password-form-module__wuwdNW__serverError",
});
